import { clsx } from 'clsx';

const variants = {
  default: 'bg-black text-white',
  infant: 'bg-[#06874C] text-white',
  toddler: 'bg-[#6AB794] text-black',
  preK: 'bg-[#5A78A0] text-white',
  k3: 'bg-[#889EBB] text-black'
};

interface AgeLevelTagProps {
  name: string;
  description: string;
}

export function AgeLevelTag({ name, description }: AgeLevelTagProps) {
  const classes = clsx(
    'inline-block px-2 py-1 font-semibold text-sm leading-4 rounded',
    // age level variant
    tagNameToVariant(name)
  );

  function tagNameToVariant(tagName: string) {
    switch (tagName) {
      case 'infant':
        return variants.infant;
      case 'toddler':
        return variants.toddler;
      case 'pre-k':
        return variants.preK;
      case 'k-3':
        return variants.k3;
      default:
        return variants.default;
    }
  }

  return <span className={classes}>{description}</span>;
}
